import {
  Component,
  Input,
  ViewEncapsulation,
} from "@angular/core";
import { SiteWarehouseDTO } from "src/app/models/Sites/siteWarehouseDTO";
import { TenantDataFormatDTO } from "src/app/models/Tenant/Tenant.model";

@Component({
  selector: "app-tank-graph",
  templateUrl: "./tank-graph.component.html",
  styleUrls: ["./tank-graph.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class TankGraphComponent {
  @Input() warehouse!: SiteWarehouseDTO;
  @Input() tenantDataFormat: TenantDataFormatDTO | null = null;

  get status(): any {
    const ss = this.warehouse?.stockStatus as any;
    return Array.isArray(ss) ? ss?.[0] : ss || null;
  }
}